import { featuresSlice } from '@app/store/slices/features/features';

export const { setFeatures, setFeaturesAll } = featuresSlice.actions;
export const { reducer: featuresReducer } = featuresSlice;
